module.exports = __webpack_public_path__ + "assets/00d922be8fd9ee92743776e05b98c947.mp3";